import { RouteObject } from 'react-router';

import { ROUTES } from '~shared/routes';

export const jobsRoutes: RouteObject = {
  path: ROUTES.jobs.root,
  children: [
    {
      index: true,
      lazy: async () => {
        const { JobsPage } = await import('../../../pages/jobs/Jobs.page');

        return { Component: JobsPage };
      },
    },
    {
      path: ROUTES.jobs.jobEdit,
      lazy: async () => {
        const { JobsFormPage } =
          await import('../../../pages/jobs/JobsForm.page');

        return { Component: () => <JobsFormPage isCopying={false} /> };
      },
    },
    {
      path: ROUTES.jobs.jobDuplicate,
      lazy: async () => {
        const { JobsFormPage } =
          await import('../../../pages/jobs/JobsForm.page');

        return { Component: () => <JobsFormPage isCopying /> };
      },
    },
  ],
};
